// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"4130e515","931":"32043121"}[chunkId] + ".chunk.js";
};